export interface BasePhase {
  id?: string;
  phaseType?: string;
  productId?: string;
  nombreFase: string;

  // Objetivos
  capObjetivoFase?: number;
  capObjetivoActual?: number;

  // Control Admin (calculados)
  pteEnvioContratoNum?: number;
  pteEnvioContratoEur?: number;
  pteFirmaNum?: number;
  pteFirmaEur?: number;
  pteTransferenciaNum?: number;
  pteTransferenciaEur?: number;
  rechazadoNum?: number;
  rechazadoEur?: number;

  // Métricas Capital (calculados)
  numInversores?: number;
  totalCaptado?: number;
  totalDevuelto?: number;
  capPdteCaptar?: number;

  // Auditoria
  active?: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface CrvPhase extends BasePhase {
  // Fechas (manuales)
  fechaInicioFase?: string;
  fechaInicioActual?: string;
  fechaDevolucionEstInicial?: string;
  fechaDevolucionEstActual?: string;
  desviacionDias?: number;

  // Condiciones (manuales)
  interesTotal?: number;
  interesAnualCuenta?: number;
  intFidelizacion?: number;
  retencionIrpf?: number;

  // Rendimientos (calculados)
  rtoAnualInicial?: number;
  rtoAnualActual?: number;

  // Métricas Interés (calculados)
  intFidelizacionEur?: number;
  interesesDevengados?: number;
  totalIntDevengados?: number;
  interesesAnticipados?: number;
  liqFinalPendiente?: number;
}

export interface CraPhase extends BasePhase {
  // Fechas (manuales)
  fechaInicioFase?: string;
  fechaInicioActual?: string;
  fechaCierreFase?: string;

  // Condiciones (manuales)
  valorContablePre?: number;
  valorTicketUd?: number;
  ticketsAEmitir?: number;
  retencionIrpf?: number;

  // Rendimientos (calculados)
  valorActualTicket?: number;
  porcentajeRevalAcumulada?: number;
  coeficienteReval?: number;

  // Métricas Capital Extra
  numTickets?: number;

  // Métricas Valor (calculados)
  intFidelizacionEur?: number;
  repartosRealizados?: number;
  liqFinalPendiente?: number;
}

export interface PhPhase extends BasePhase {
  // Fechas (manuales)
  fechaInicioFase?: string;
  fechaInicioActual?: string;
  fechaDevolucionEstInicial?: string;
  fechaDevolucionEstActual?: string;
  desviacionDias?: number;

  // Condiciones (manuales)
  interesTotal?: number;
  interesAnualFijo?: number;
  intFidelizacion?: number;
  retencionIrpf?: number;

  // Rendimientos (calculados)
  rtoAnualInicial?: number;
  rtoAnualActual?: number;

  // Métricas Interés (calculados)
  intFidelizacionEur?: number;
  interesesDevengados?: number;
  totalIntDevengados?: number;
  interesesPagados?: number;
  liqFinalPendiente?: number;
}

export type Phase = CrvPhase | CraPhase | PhPhase;

export type PhaseType = 'crv' | 'cra' | 'ph';

export const FRECUENCIA_PAGO_OPTIONS = [
  { value: 'Mensual', label: 'Mensual' },
  { value: 'Trimestral', label: 'Trimestral' },
  { value: 'Semestral', label: 'Semestral' },
];
